import { render } from "./hiddenRealms.vue?vue&type=template&id=624229ee&scoped=true"
import script from "./hiddenRealms.vue?vue&type=script&lang=js"
export * from "./hiddenRealms.vue?vue&type=script&lang=js"

import "./hiddenRealms.vue?vue&type=style&index=0&id=624229ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624229ee"]])

export default __exports__